import { cx } from '@/lib/cva-config'
// import { Footer } from './footer'
import { Sidebar } from './sidebar'
import { useSidebar } from './use-sidebar'
import { useStore } from './use-store'

export default function AdminPanelLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const sidebar = useStore(useSidebar, (x) => x)
  if (!sidebar) return null

  const { getOpenState, settings } = sidebar
  return (
    <>
      <Sidebar />
      <main
        className={cx(
          'min-h-lvh',
          'bg-zinc-100 transition-[margin-left] duration-300 ease-in-out dark:bg-zinc-900',
          !settings.disabled && (!getOpenState() ? 'lg:ml-[90px]' : 'lg:ml-72')
        )}
      >
        {children}
      </main>
      {/* <footer
        className={cx(
          'transition-[margin-left] duration-300 ease-in-out',
          !settings.disabled && (!getOpenState() ? 'lg:ml-[90px]' : 'lg:ml-72')
        )}
      >
        <Footer />
      </footer> */}
    </>
  )
}
